import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSession, isAuthenticated } from "./adminAuth";
import { useTranslation } from "react-i18next";

interface AdminGuardProps {
  children: React.ReactNode;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const session = getSession();
    if (!session || !isAuthenticated()) {
      navigate("/login", { replace: true, state: { from: location.pathname } });
    } else {
      setChecking(false);
    }
  }, [location.pathname, navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#2A2A2A] text-[#E0E0E0]">
        <div className="animate-pulse px-6 py-4 rounded-lg bg-[#1f1f1f] border border-[#2f2f2f]">
          {t('common.checkingSession')}
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminGuard;
